import React from 'react';

import styles from './SubmittedTableHeader.module.scss';
import TableCell from 'components/TableCell';
import TableHead from 'components/TableHead';
import TableRow from 'components/TableRow';

function SubmittedTableHeader() {
  return (
    <>
      <TableHead className={styles.root}>
        <TableRow>
          <TableCell className={styles.heading}>Learner Info</TableCell>
          <TableCell className={styles.heading}>Phone number</TableCell>
          <TableCell className={styles.heading}>Submit Date</TableCell>
          <TableCell className={styles.heading}>Program</TableCell>
          <TableCell className={styles.heading}>Email</TableCell>
          <TableCell className={styles.heading}>Github Link</TableCell>
          <TableCell className={styles.heading}>Thesis</TableCell>
          <TableCell className={styles.heading}>Project Zip</TableCell>
          <TableCell className={styles.heading}>Status</TableCell>
          <TableCell className={styles.heading}>Date of Resolution</TableCell>
        </TableRow>
      </TableHead>
    </>
  );
}

export default SubmittedTableHeader;
